const listingTypes = [
  {
    slug: 'yacht-rentals',
  },
  {
    slug: 'pontoon-boat-rentals',
  },
  {
    slug: 'cruising-catamaran-rental',
  },
  {
    slug: 'wakeboarding',
  },
  {
    slug: 'tours',
  },
];

export default listingTypes;
